const register_account = {
  title: "アートシフトトレーニングアプリ\n利用希望フォーム",
  sub_title: "以下の情報をご記入ください",
  personal_section: {
    title: "お名前",
    full_name_kanji: "氏名",
    last_name_kanji_placeholder: "山田",
    first_name_kanji_placeholder: "太郎",
    full_name: "氏名（カナ）",
    last_name_placeholder: "ヤマダ",
    first_name_placeholder: "タロウ",
    date_of_birth: "生年月日",
    gender: "性別",
    gender_placeholder: "ご選択ください",
  },
  contact_section: {
    title: "ご連絡先",
    email_address: "メールアドレス",
    email_address_placeholder: "ご記入ください",
    phone_number: "携帯電話",
    phone_number_placeholder: "ご記入ください",
  },
  address_section: {
    title: "ご住所",
    post_code: "郵便番号",
    post_code_placeholder: "ご記入ください",
    address: "住所",
    address_placeholder: "ご記入ください",
  },
  service_section: {
    title: "サービスをご希望利用",
    graduation: "卒業期",
    graduation_placeholder: "ご選択ください",
    graduation_memo: "受講期間中は0円。受講期間終了後、登録プランに基づいた料金が適用されます。",
    plan: {
      number_of_students: "受講生管理可能人数 {{limit_students}}人",
      price: "{{price}}円",
      unit: "/月（税込）"
    },
  },
  term_of_use_section: {
    title: "利用規約及びプライバシーポリシー",
    term_of_use: "利用規約",
    privacy_policy: "プライバシーポリシー",
  },
  agree_checkbox: "同意する",
  button_submit: "次のステップに進む",
  footer_section: {
    privacy_policy: "プライバシーポリシー",
    commercial_transaction: "特定商取引法に基づく表記",
    copyright: "Copyright(c) アートシフトコーチングスクール All Rights Reserved.",
  },
  error: {
    phone_number_length: "携帯電話が10桁から15桁以内で入力してください。",
    cannot_create_account: "アカウントの作成に失敗しました。時間をおいて再度お試しください。",
  }
}

export default register_account;